import { createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentTemplatePrintType } from '@/Models';
import { DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { GetDocumentsInfoResponse } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoResponse';
import { GetDocumentsInfoRequest } from '@/Api/_Microservices/OnlineArchive/Documents/GetDocumentsInfoRequest';
import { DocumentsApi } from '@/Api/_Microservices/OnlineArchive/Documents';
import { GetAllDocumentTemplateResponse } from '@/Api/DocumentTemplates/Responses/GetAllDocumentTemplateResponse';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';

const getDocumentTemplates = createAsyncThunk<GetAllDocumentTemplateResponse, DocumentTemplatePrintType>(
  'documentPrintModalSlice/getAll',
  async (documentType: DocumentTemplatePrintType) => {
    return DocumentTemplateApi.getAllDocumentTemplates(DocumentTemplateType.Document, documentType);
  },
);

const getDocumentsForPrint = createAsyncThunk<GetDocumentsInfoResponse, GetDocumentsInfoRequest>(
  'documentPrintModalSlice/get-documents-for-print',
  async (request) => {
    return DocumentsApi.getDocumentsInfo(request);
  },
);

export const asyncActions = {
  getDocumentTemplates,
  getDocumentsForPrint,
};
